import { call } from 'redux-saga/effects';

import * as pageInitializerService from '../page.initializer.saga-service';
import * as pageStateService from '../page-state/page-state.saga-services';

export function* initialMeetingPage() {
  yield call(pageStateService.initPage, 'home');
  yield call(pageInitializerService.initPage);
  yield call(pageStateService.completedInit, 'home');
}
